import React from "react";
import { Link } from "react-router-dom";

import QueryButton
  from "../components/query/QueryButton";

import "../styles/website.css";
import "../styles/home.css";


const HomePage = () => {

  return (
    <div className="website">

      <main>

        {/* HERO */}

        <section className="home-hero">

          <div className="hero-content">

            <div className="hero-badge">
              Modern Technology Solutions
            </div>

            <h1>
              Technology that
              <span> grows with your business.</span>
            </h1>

            <p>
              Harsha IT builds reliable websites, business
              applications and software solutions for schools,
              restaurants, pharmacies, hotels and growing
              businesses.
            </p>

            <div className="hero-actions">

              <QueryButton>
                Start a Conversation
              </QueryButton>

              <Link
                to="/products"
                className="secondary-button"
              >
                Explore Products
                <span>→</span>
              </Link>

            </div>

          </div>


          <div className="hero-visual">

            <div className="hero-card main-card">

              <div className="hero-card-top">

                <span className="status-dot" />

                Business Platform

              </div>


              <div className="dashboard-preview">

                <div className="preview-sidebar">

                  <span />
                  <span />
                  <span />
                  <span />

                </div>


                <div className="preview-content">

                  <div className="preview-header" />


                  <div className="preview-stats">

                    <div />
                    <div />
                    <div />

                  </div>


                  <div className="preview-chart" />

                </div>

              </div>

            </div>


            <div className="floating-card card-one">

              <strong>
                99.9%
              </strong>

              <span>
                Reliable
              </span>

            </div>


            <div className="floating-card card-two">

              <strong>
                24/7
              </strong>

              <span>
                Business Ready
              </span>

            </div>

          </div>

        </section>


        {/* SERVICES */}

        <section className="home-section">

          <div className="section-heading">

            <span className="section-label">
              WHAT WE DO
            </span>

            <h2>
              Solutions built for
              <span> real businesses.</span>
            </h2>

            <p>
              We combine clean design, modern technology
              and practical business workflows to create
              software that actually helps organizations.
            </p>

          </div>


          <div className="service-grid">

            <div className="service-card">

              <div className="service-icon">
                S
              </div>

              <h3>
                School Solutions
              </h3>

              <p>
                Digital platforms and websites designed
                for schools, students, teachers and
                administrators.
              </p>

            </div>


            <div className="service-card">

              <div className="service-icon">
                R
              </div>

              <h3>
                Restaurant Solutions
              </h3>

              <p>
                Manage menus, inventory, orders and
                day-to-day restaurant operations.
              </p>

            </div>


            <div className="service-card">

              <div className="service-icon">
                P
              </div>

              <h3>
                Pharmacy Solutions
              </h3>

              <p>
                Inventory, sales and business management
                tools for pharmacies.
              </p>

            </div>


            <div className="service-card">

              <div className="service-icon">
                H
              </div>

              <h3>
                Hotel Solutions
              </h3>

              <p>
                Technology solutions for hotels and
                hospitality businesses.
              </p>

            </div>

          </div>

        </section>


        {/* PRODUCTS CTA */}

        <section className="home-product-banner">

          <div>

            <span className="section-label">
              OUR PRODUCTS
            </span>

            <h2>
              One technology partner.
              <br />
              Multiple business solutions.
            </h2>

          </div>


          <Link
            to="/products"
            className="white-button"
          >
            View Products →
          </Link>

        </section>


        {/* CTA */}

        <section className="home-cta">

          <span className="section-label">
            LET'S BUILD
          </span>

          <h2>
            Have an idea?
            <br />
            Let's turn it into reality.
          </h2>

          <p>
            Tell us what your business needs and we'll
            help you find the right technology solution.
          </p>

          <QueryButton>
            Contact Harsha IT
          </QueryButton>

        </section>

      </main>

    </div>
  );
};


export default HomePage;